module.exports = __webpack_public_path__ + "img/tagtiv8.912ac0a8.png";